import routes from './routes/index'

export default routes
